import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const KEY = "qg_visitor";

export function visitorId() {
  let v = localStorage.getItem(KEY);
  if (!v) {
    v = (window.crypto?.randomUUID?.() || `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`).replace(/-/g, "").slice(0, 32);
    localStorage.setItem(KEY, v);
  }
  return v;
}

/* Records one page view per route change (admin pages are ignored server-side) and notifies Statcounter of SPA navigations. */
export default function PageViewTracker() {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    api.post("/analytics/view", { path: pathname, visitor_id: visitorId(), referrer: document.referrer || null }).catch(() => {});
    if (first.current) { first.current = false; return; } // initial load is counted by counter.js itself
    window._statcounter?.record_pageview?.();
  }, [pathname]);
  return null;
}
